
import './components/covid.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import CovidTracker from './components/CovidTracker';

function App() {
  return (
    <>
    
<CovidTracker  />
    </>
  );
}

export default App;
